export default __webpack_public_path__ + "static/media/logo-horizontal.2f256696.svg";